export default __webpack_public_path__ + "static/media/prev-img.29c0dbec.svg";